import axios from 'axios';
import { toast } from 'sonner';
import { API_URL } from '../../lib/utils';

const fileSafe = (name) => name.replace(/\s+/g, '_');
const today = () => new Date().toISOString().split('T')[0];

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

const escapeCsvCell = (value) => {
  if (value == null) return '';
  if (typeof value === 'string' && value.includes(',')) return `"${value}"`;
  return value;
};

export function exportReportToCSV({ rows, selectedFields, getFieldLabel, reportName }) {
  if (rows.length === 0) {
    toast.error('No data to export');
    return;
  }
  const headers = selectedFields.map(getFieldLabel);
  const csvContent = [
    headers.join(','),
    ...rows.map((row) => selectedFields.map((f) => escapeCsvCell(row[f])).join(','))
  ].join('\n');
  downloadBlob(new Blob([csvContent], { type: 'text/csv;charset=utf-8;' }), `${fileSafe(reportName)}_${today()}.csv`);
  toast.success('CSV exported');
}

export async function exportReportToPDF({ rows, selectedFields, selectedModules, getFieldLabel, reportName }) {
  if (rows.length === 0) {
    toast.error('No data to export');
    return;
  }
  try {
    const response = await axios.post(
      `${API_URL}/reports/export-custom-pdf`,
      {
        report_name: reportName,
        module: selectedModules.join('+'),
        fields: selectedFields,
        field_labels: selectedFields.map(getFieldLabel),
        data: rows.slice(0, 100)
      },
      { withCredentials: true, responseType: 'blob' }
    );
    downloadBlob(new Blob([response.data]), `${fileSafe(reportName)}_${today()}.pdf`);
    toast.success('PDF exported');
  } catch {
    toast.error('Failed to export PDF');
  }
}
